import { useEffect } from 'react';

export const useRefocusOnAddressInput = (
  isRefocusingAddressInput: boolean,
  setIsRefocusingAddressInput: (v: boolean) => void,
  addressInputElementRef: React.RefObject<HTMLInputElement | undefined>,
) => {
  useEffect(() => {
    if (isRefocusingAddressInput) {
      addressInputElementRef?.current?.focus();
      setIsRefocusingAddressInput(false);
    }
  }, [isRefocusingAddressInput]);
};

export const useRefocusOnUnitInput = (
  unitNumberDetected: boolean,
  isSubmitDisabled: boolean,
  unitNumberInputElementRef: React.RefObject<HTMLInputElement | undefined>,
) => {
  useEffect(() => {
    if (!isSubmitDisabled && unitNumberDetected && unitNumberInputElementRef.current) {
      unitNumberInputElementRef.current.focus();
      unitNumberInputElementRef.current.scrollIntoView(false);
    }
  }, [isSubmitDisabled]);
};
